export default function ({ store, redirect, app }) {
  if (store.getters['auth/isAuthenticated'])
    return redirect({ path: app.localePath('index') })
}
